<template>
  <div v-loading="loading">
    <p class="title">{{ detaile.title }}</p>
    <p class="time">发布时间：{{ detaile.releaseTime | formatDate }}</p>
    <div v-html="detaile.content"></div>
    <div class="clearfix">
      <p v-if="detaile.beforeId" class="fl other" @click="$router.push({ name: 'honorDetails', query: { id: detaile.beforeId } })"><i class="el-icon-arrow-left"></i>上一篇：{{ detaile.beforeTitle }}</p>
      <p v-if="detaile.afterId" class="fr other" @click="$router.push({ name: 'honorDetails', query: { id: detaile.afterId } })">下一篇：{{ detaile.afterTitle }}<i class="el-icon-arrow-right"></i></p>
    </div>
  </div>
</template>

<script>
import { formatdate } from "@/utils/index";
export default {
  data() {
    return {
      detaile: {},
      loading:false
    }
  },
  filters: {
    formatDate(time) {
      if (!time) return
      var date = new Date(time)
      return formatdate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  },
  created() {
    this.loading = true;
    this.$http.post(this.$api.systemApi.detaile, {
      id: this.$route.query.id
    }).then(({ data }) => {
      this.loading = false;
      this.detaile = data.data;
    }).catch(()=>{
      this.loading = false;
    });
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin: 0;
  line-height: 28px;

  &::after {
    width: 24px;
    height: 3px;
    border-radius: 6px;
    background: #D4D4D4;
    margin: 0 auto;
    content: "";
    display: block;
    position: relative;
    top: 8px;
  }
}

.time {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  line-height: 20px;
  color: #999;
  text-align: center;
  margin: 20px 0;
}

.other {
  font-size: 14px;
  cursor: pointer;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #2962B0
}</style>
